import JobFullListContainer from "../../../components/job/other/JobFullList";

const JobFullList = () => {
  return <JobFullListContainer />;
};

export default JobFullList;
